import { isNullOrUndefined } from './collection';

interface ResizeCallback {
  callback: () => void;
  duration: number;
  timeout?: NodeJS.Timeout;
}

const defaultTimeout = 50;

const callbacks: ResizeCallback[] = [];

window.onresize = () => {
  callbacks.map((cb: ResizeCallback) => {
    if (isNullOrUndefined(cb.timeout)) {
      cb.callback();
      cb.timeout = setTimeout(() => {
        cb.timeout = null;
      }, cb.duration);
    }
  });
};

/**
 * Subscribe to the resize listener
 * @param {function} callback The callback function to run on resize
 * @param {number} timeoutDuration The throttle timeout duration
 */
export const subscribeToWindowResize = (callback: () => void, timeoutDuration: number = defaultTimeout): void => {
  callbacks.push({ callback, duration: timeoutDuration });
};

/**
 * Unsubscribe to the resize listener
 * @param {function} callback The callback function to unsubscribe
 */
export const unSubscribeToWindowResize = (callback: () => void): void => {
  const index = callbacks.findIndex((cb: ResizeCallback) => cb.callback === callback);
  if (index >= 0) {
    if (!isNullOrUndefined(callbacks[index].timeout)) {
      clearTimeout(callbacks[index].timeout);
    }
    callbacks.splice(index, 1);
  }
};
